import { SxcApp } from '@2sic.com/sxc-angular';
import { httpResource } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserProfile } from '../auth/auth.service';
import { CompanyProfile } from '../company-profile/company-profile.component';
import { EditCompanyFormValue } from '../company-profile/edit-company/edit-company.component';
import { EditProfileFormValue } from '../my-profile/edit-profile/edit-profile.component';
import { AddUserFormValue } from '../user-management/add-user/add-user.component';
import { UserListData } from '../user-management/user-management.component';

@Injectable({
  providedIn: 'root',
})
export class ProfileApiService {
  constructor(private app: SxcApp) {}

  getUserProfile() {
    return this.app.api('Profile').get<UserProfile>(
      'GetUserProfile',
      {}, // <- urlParams,
    );
  }

  getCompanyProfile() {
    return httpResource<CompanyProfile>(() => ({
      url: this.app.api('Profile').url('GetCompanyProfile'),
      method: 'GET',
      body: {},
    })).value;
  }

  updateUserProfile(userProfileValue: EditProfileFormValue): Observable<any> {
    return this.app.api('Profile').post<any>(
      'UpdateUserProfile',
      {}, // <- urlParams,
      userProfileValue as unknown as any, // Bug 2sxc Post Api Body and Request same Type
    );
  }

  updateCompanyProfile(companyProfileValue: EditCompanyFormValue): Observable<any> {
    return this.app.api('Profile').post<any>(
      'UpdateCompanyProfile',
      {}, // <- urlParams,
      companyProfileValue as unknown as any, // Bug 2sxc Post Api Body and Request same Type
    );
  }

  getUsers() {
    return httpResource<UserListData[]>(() => ({
      url: this.app.api('Profile').url('GetUsers'),
      method: 'GET',
      body: {},
    })).value;
  }

  addUser(addUserValue: AddUserFormValue) {
    return this.app.api('Profile').post<any>(
      'AddUser',
      {}, // <- urlParams,
      addUserValue as unknown as any, // Bug 2sxc Post Api Body and Request same Type
    );
  }

  deleteUser(user: UserListData) {
    return this.app.api('Profile').post<any>(
      'DeleteUser',
      {}, // <- urlParams,
      user as unknown as UserListData, // Bug 2sxc Post Api Body and Request same Type
    );
  }
}
